export const BASE_IMAGE_URL = 'https://image.tmdb.org/t/p/original'